export default __webpack_public_path__ + "static/media/work.ade2b282.png";